import { SWRConfiguration, SWRResponse } from "swr";

import { ClientAppSettingsResponse, GetClientAppSettings } from "../../api/dtos/dtos";
import useGet from "../api/useGet";

const request = () => new GetClientAppSettings();
const getData = (response?: SWRResponse<ClientAppSettingsResponse, ClientAppSettingsResponse>) => response?.data?.appSettings;
const getError = (response?: SWRResponse<ClientAppSettingsResponse, ClientAppSettingsResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (_?: SWRResponse<ClientAppSettingsResponse, ClientAppSettingsResponse>) => ({});

const useGetClientAppSettings = (configuration?: SWRConfiguration) => {

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useGetClientAppSettings;